<div class="tw-flex tw-gap-2 md:tw-gap-6 tw-justify-center">
    <div *ngFor="let table of comparisonTable; let i = index;">
        <div [ngClass]="{'tw-text-pinkDark tw-border-[1px] tw-border-pinkDark tw-tw-pinkDark': table.header.bodyType === selectedElement.header.bodyType}"
            class="tw-shadow tw-rounded-md tw-font-bold tw-text-gray-500 tw-py-3 tw-px-3 md:tw-px-6 tw-text-xs"
            (click)="onHeaderClick(i)">
            {{table?.header?.bodyType}}
        </div>
    </div>
</div>

<div class="tw-text-xs tw-p-4 md:tw-px-32 ">
    <div class="tr tw-grid tw-grid-cols-8 tw-text-center">
        <div class="tw-col-span-4"></div>
        <div class="tw-col-span-2 tw-bg-[#F7B703]/[0.2] tw-px-1.5 tw-py-2">PPP Lease</div>
        <div class="tw-col-span-2 tw-py-2">Loan</div>
    </div>
    <div class="tr" *ngFor="let row of selectedElement.table">
        <div class="tw-grid tw-grid-cols-8">
            <div class="td tw-col-span-4">{{row.label}}</div>
            <div class="td tw-col-span-2 tw-text-center">
                <div *ngIf="row.leaseCol === 'true'">
                    <fa-icon [icon]="faCheck" class="tw-text-greenMid"></fa-icon>
                </div>
                <div *ngIf="row.leaseCol !== 'true'" [ngClass]="{'tw-text-lg': row.label === 'Monthly Cost'}">
                    {{row.leaseCol}}
                </div>
            </div>
            <div class="td tw-col-span-2 tw-text-center">
                {{row.loanCol}}
            </div>
        </div>
    </div>
</div>
<div class="tw-text-center tw-mt-4 tw-font-bold tw-text-base md:tw-text-lg">Save Upto<span
        class="tw-text-pinkDark tw-pl-2 tw-font-extrabold tw-text-xl md:tw-text-2xl">{{selectedElement.footer.footerLine}}
    </span></div>